var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.557,
    height: 17.557,
    viewBox: "0 0 17.557 17.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702",
    transform: "translate(-348.814 -3.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-account-circle",
    "data-name": "Icon material-account-circle",
    d: "M12.009,6.031A2.483,2.483,0,1,1,9.525,8.515,2.48,2.48,0,0,1,12.009,6.031Zm0,11.755a5.961,5.961,0,0,1-4.967-2.666c.025-1.647,3.311-2.55,4.967-2.55s4.942.9,4.967,2.55A5.961,5.961,0,0,1,12.009,17.787Z",
    transform: "translate(345.584 0.865)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-account-circle-2",
    "data-name": "Icon material-account-circle",
    d: "M11.278,3a8.278,8.278,0,1,0,8.278,8.278A8.281,8.281,0,0,0,11.278,3Z",
    transform: "translate(346.314 1.414)",
    fill: "none",
    stroke: "#444",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc);
export default __webpack_public_path__ + "static/media/acc.11f9a342.svg";
export { ForwardRef as ReactComponent };